<template>
  <section :id="epoch.epochType" :class="['epoch', epoch.epochType]">
    <template v-for="item in epoch?.timelineMapItems">
      <MomentJVM v-if="item.type=='Moment'" :key="item.urlSegment" :moment="item" />
      <Decoration v-else :decoration="item" />
    </template>
  </section>
</template>

<script lang="ts" setup>
import MomentJVM from "../moment/MomentJVM.vue";
import Decoration from "../decoration/Decoration.vue";
import { IEpoch } from "../../interfaces/IEpoch";

defineProps<{ epoch: IEpoch }>()
</script>
